import { GamepadCircleOutlineIcon } from './GamepadCircleOutlineIcon';

/**
 * author: Haley Halcyon
 * id D227F063-202F-4B7D-9175-790055F07506
 * name gamepad-circle-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-circle-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerCircleOutlineIcon = GamepadCircleOutlineIcon;
export default ControllerCircleOutlineIcon